var e={slideX:{small:{value:"translateX(0.5em)"},medium:{value:"translateX(1em)"},large:{value:"translateX(2em)"}}};export{e as transforms};
//# sourceMappingURL=transforms.js.map
